import type { FailCodeFigureEntity } from '../entities';

import { StsBackendOperation } from '../../sts-backend-operation';

/**
 * Parameters for looking up fail code figures within a given section and subsection.
 */
export type LookupFiguresParams = {
    /** The vehicle model code (e.g. "GUE"). */
    modelCode?: string;

    /** The vehicle model year (e.g. "2024"). */
    modelYear?: string;

    /** The vehicle option/trim code (e.g. "01"). */
    optionCode?: string;

    /** The display name of the parent section. */
    sectionName: string;

    /** The numeric identifier of the parent section. */
    sectionNumber: number;

    /** Optional abort signal for cancellation. */
    signal?: AbortSignal;

    /** The display name of the parent subsection. */
    subsectionName: string;

    /** The numeric identifier of the parent subsection. */
    subsectionNumber: number;
};

/**
 * Look up fail code figures for a vehicle, section, and subsection.
 * Used in the lookup-by-section flow after the user selects a subsection.
 */
export class LookupFigures extends StsBackendOperation {
    /**
     * Look up figures from the API and return them as domain entities.
     *
     * @param params - the vehicle identifiers and parent section/subsection
     * @returns the matching figures as domain entities
     */
    async exec(params: LookupFiguresParams): Promise<FailCodeFigureEntity[]> {
        const { signal, ...request } = params;
        const response = await this.client.lookupFailCodeFigures(request, signal);

        if (!response.success) {
            return [];
        }

        return response.data.figures ?? [];
    }
}
